// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';
import BasketItemSchema from './basket-item-schema';
import OnlinePaymentSchema from './online-payment-schema';

const schema = {
  $id: '/calculate-membership-by-entry-date-request-schema',
  type: 'object',
  required: ['id', 'businessUnitNumber', 'membershipCategoryId', 'grossTotal', 'productDefinitionId', 'membershipEntryDate', 'isReEntry'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    businessUnitId: {
      type: 'string',
      format: 'uuid',
    },
    businessUnitNumber: {
      type: 'integer',
    },
    businessPostalCode: {
      type: 'string',
      nullable: true,
    },
    membershipCategoryId: {
      type: 'integer',
    },
    payrollCategoryId: {
      type: 'string',
      format: 'uuid',
      nullable: true,
    },
    grossTotal: {
      type: 'number',
    },
    currency: {
      type: 'string',
      nullable: true,
    },
    items: {
      type: 'array',
      nullable: true,
      items: { ...BasketItemSchema },
    },
    periodStart: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    periodEnd: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    paymentMethod: {
      enum: [
        1,
        2,
        3,
        6,
        7,
        8,
      ],
    },
    onlinePayment: {
      ...OnlinePaymentSchema,
    },
    productDefinitionId: {
      type: 'string',
      format: 'uuid',
    },
    membershipEntryDate: {
      type: 'string',
      format: 'date-time',
    },
    isReEntry: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
